import { module } from 'modujs';
import Sortable from 'sortablejs';
import axios from "axios";
export default class extends module {
    constructor(m) {

        super(m);
        Sortable.create( this.el, {
            animation: 150,
            handle: '.handle',

            onEnd:  (event) => {
                let handle = event.originalEvent.target;

                handle.classList.add('dragging');
                console.info(handle );

                let itemIds = [];
                [...this.$( 'item' )].forEach( item => {
                    itemIds.push(item.getAttribute('data-id'));
                });
                axios.post( THEME_OBJ.ajaxURL, new URLSearchParams({
                    action: 'iw-auth-sort-items',
                    itemIds: itemIds,
                    type: this.el.dataset.type
                })).then(response => {
                    handle.classList.remove('dragging');
                    if (response.data.success) {
                        console.log('Order updated successfully.');
                    } else {
                        console.error('Failed to update experience order:', response.data.message);
                    }
                })
                .catch(error => console.error('Axios Error:', error));
            }
        });
    }
    init() {}
    destroy(){}
}



